<script lang="ts">
import { TableOutlined } from '@ant-design/icons-vue';
import {
  Popover, Tooltip, Button, CheckboxGroup, Checkbox,
} from 'ant-design-vue';
import type { CheckboxValueType } from 'ant-design-vue/es/checkbox/interface';
import { computed, defineComponent, ref } from 'vue';
import { array } from 'vue-types';

import type { ColumnsAvailableValueProps } from './useColumnsFilter';

export default defineComponent({
  name: 'TableColumnSelect',
  components: {
    Popover,
    Tooltip,
    Button,
    TableOutlined,
    CheckboxGroup,
    Checkbox,
  },
  props: {
    modelValue: array<CheckboxValueType>(),
    columnsFilter: array<ColumnsAvailableValueProps>().isRequired,
  },
  emits: ['update:modelValue'],
  setup(properties, { emit }) {
    const value = computed({
      get: () => properties.modelValue,
      set: (newValue) => emit('update:modelValue', newValue),
    });
    return {
      visible: ref(false),
      value,
    };
  },
});
</script>
<template>
  <Popover v-model:open="visible" placement="bottomLeft" trigger="click">
    <Tooltip title="Select Columns">
      <Button size="small" data-test-id="select-columns" @click.prevent>
        <TableOutlined />
      </Button>
    </Tooltip>
    <template #content>
      <CheckboxGroup v-model:value="value" class="!block">
        <div
          v-for="column in columnsFilter"
          :key="column.key"
          class=" mb-1"
        >
          <Checkbox :value="column.key">
            {{ column.title }}
          </Checkbox>
        </div>
      </CheckboxGroup>
    </template>
  </Popover>
</template>
